import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";

/** 
 * Finalise `loginRedirect` / `acquireTokenRedirect` au retour sur l'application.
 * Gère le retour de l'authentification Microsoft après redirection.
 */
export function MsalRedirectHandler(): null {
    const { instance } = useMsal();

    useEffect(() => {
        // Gérer le retour de redirection Microsoft
        instance.handleRedirectPromise()
            .then((response) => {
                if (response) {
                    console.log('[MsalRedirectHandler] Authentication successful:', response.account?.username);
                }
            })
            .catch((error) => {
                console.error('[MsalRedirectHandler] Error handling redirect:', error);
            });
    }, [instance]);

    return null;
}
